module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": require("../assets/download/start_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_btn),
      expression: "popup_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": _vm.goDownload
    }
  }, [_vm._v("Tekan")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-close",
    attrs: {
      "src": require("../assets/download/close_icon.png")
    },
    on: {
      "click": _vm.handleClose
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa1c8f08","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadPopup.vue
// module id = 504
// module chunks = 1 2 3 4 5 6